import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { Card } from '../../class/card';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { FileUploadComponent } from '../new/file-upload/file-upload.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {

  cards: Card[];
  cardsRef: AngularFireList<any>;
  chach: boolean = true;
  userkey: string;
  username: string;
  contextmenu = true;
  innerHeight: any;
  innerWidth: any;

  constructor(
    private router: Router,
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth,
  ) { 
    this.innerHeight = window.screen.height;
    this.innerWidth = window.screen.width;
  }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      if (user) {
        this.userkey = `users/${user.uid}/cards`;
        this.chach = true;
      } else {
        this.userkey = 'cards';
        this.chach = true; 
      }
      this.cardsRef = this.db.list(this.userkey, ref  => ref.orderByChild('index'));
      this.cardsRef.snapshotChanges()
      .subscribe(snapshots => {
        if(this.chach){
          this.cards = snapshots.map(snapshot => {
            const values = snapshot.payload.val();
            return new Card({ key: snapshot.payload.key, ...values });
          });
        this.chach = false; 
        }
      });
    });
  }

  update(cards): void {
    for (let i = 0; i < cards.length; i++){
    this.cardsRef.update(this.cards[i].key, {index: i})
    }
  }

  titlestyle(title){
    if(this.innerWidth<1024){
      let styles = {
        'font-size': title.length>4 ? `${-0.6214 * title.length + 7.9357 }vw` : '6vw',
        'padding' : title.length>4 ? `${0.3929 * title.length - 1.3214 }vw 0` : '0'  
        }
      return styles;
    } else{
      let styles = {
        'font-size': title.length>5 ? `${-0.25 * title.length + 3.1}vw` : '2vw',
        //blod 'padding' : title.length>5 ? `${0.0874 * title.length - 0.399 }rem 0rem` : '0rem'
        'padding' : title.length>5 ? `${0.145 * title.length - 0.61 }vw 0` : '0'  
      }
    return styles;
    }
  }

  picstyle(){
    let styles = {
      'width': this.innerWidth<1024 ? '25vw' : '10vw',
      'height': this.innerWidth<1024 ? '25vw' : '10vw'
    }
    return styles;
  }

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/card/dashboard/dashboard.component.ts